<template>
    <button
        type="button"
        class="announcements-button"
        title="Avisos"
        aria-label="Avisos"
        @click="$emit('click')"
    >
        <a-badge :count="count" :offset="[2, -2]">
            <span class="material-icons-outlined announcements-icon">campaign</span>
        </a-badge>
    </button>
</template>

<script>
export default {
    name: "AnnouncementsButton",
    props: {
        count: { type: Number, default: 0 },
    },
};
</script>

<style>
/* Cabeçalho desta linha tem fundo na cor primária: ícone branco, como os demais. */
.announcements-button {
    display: flex;
    align-items: center;
    cursor: pointer;
    border: 0;
    padding: 0;
    margin-right: 12px;
    background: transparent;
    color: white;
    line-height: 1;
}
.announcements-button .announcements-icon {
    color: white;
    font-size: 28px;
}
.announcements-button:focus {
    outline: none;
}
</style>
